import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    mode;
    disabled;
    formData = {
        mode: this.$props.mode,
    };
    modeChange(val) {
        this.formData.mode = val;
    }
    changeLevel(val) {
        this.$emit('update:mode', val);
    }
    isValidate() {
        return true;
    }
};
__decorate([
    Prop()
], default_1.prototype, "mode", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
__decorate([
    Watch('mode')
], default_1.prototype, "modeChange", null);
default_1 = __decorate([
    Component({
        name: 'AlarmLevel',
        components: {},
        i18n: {
            messages: {
                zh: {
                    title: '告警方式',
                    matched: '比中告警',
                    unmatched: '未比中告警',
                    none: '不告警',
                    both: '均告警',
                },
                en: {
                    title: 'Mode',
                    matched: 'Matched',
                    unmatched: 'Unmatched',
                    none: 'None',
                    both: 'Both',
                },
            },
        },
    })
], default_1);
export default default_1;
